import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResourceService } from '../../generics/services/generic-http.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { RolePermission } from '../models/role-permission.model';

@Injectable({ providedIn: 'root' })
export class RolePermissionService extends ResourceService<RolePermission> {

  constructor(private http: HttpClient) {
    super(http, RolePermission, environment.apiUri + "/rolePermissions");
  }

  public getAll<T>(): Observable<T[]> {
    return this.http
      .get<T[]>(this.apiUrl + "/all");
  }

  public getAllFrontEndPermissions<T>(roleID: number = 0): Observable<T> {
    return this.http
      .get<T>(this.apiUrl + `/frontend?roleID=${roleID}`);
  }

  public getFrontEndPermissions<T>(roleID: number = 0): Observable<T> {
    return this.http
      .get<T>(this.apiUrl + `/role/${roleID}`);
  }

}
